import { render, staticRenderFns } from "./ImportCostsToInvoice.vue?vue&type=template&id=70c829f6&scoped=true&"
import script from "./ImportCostsToInvoice.vue?vue&type=script&lang=js&"
export * from "./ImportCostsToInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ImportCostsToInvoice.vue?vue&type=style&index=0&id=70c829f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c829f6",
  null
  
)

export default component.exports